import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import CloseButtonSvg from '../../images/icons/close-modal.svg'

export const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.opacity.black80};
`

export const CloseButton = styled(CloseButtonSvg)`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  box-sizing: border-box;
  cursor: pointer;
`

export const StyledCard = styled.div`
  flex-direction: row;
  display: flex;
  background-color: ${({ theme }) => theme.colors.unique.white};
  max-width: ${pxToRem(792)};
  max-height: ${pxToRem(500)};
`

export const StyledBody = styled.div`
  flex-direction: column;
  display: flex;
  margin: ${pxToRem(20)} ${pxToRem(10)} ${pxToRem(20)} ${pxToRem(20)};
`

export const StyledHeader = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin-right: ${pxToRem(10)};
`

export const StyledTitle = styled.div`
  margin-bottom: ${pxToRem(10)};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
`

export const StyledText = styled.div`
  padding-right: ${pxToRem(10)};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  overflow: auto;
  color: ${({ theme }) => theme.colors.opacity.black70};

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
`
